import { ThemeEvents } from '@theme/events';

class ProductSku extends HTMLElement {
  connectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.addEventListener(ThemeEvents.variantUpdate, this.updateSku);
  }

  disconnectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.removeEventListener(ThemeEvents.variantUpdate, this.updateSku);
  }

  updateSku = (/** @type {import('@theme/events').VariantUpdateEvent} */ event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const newSkuElement = /** @type {HTMLElement|null} */ (event.detail.data.html.querySelector('product-sku .product-sku__value'));
    const currentSkuElement = this.querySelector('.product-sku__value');

    if (!currentSkuElement) return;

    if (!newSkuElement || !newSkuElement.dataset.sku) {
      this.style.display = 'none';
      return;
    }

    this.style.display = '';
    currentSkuElement.textContent = newSkuElement.textContent;
  };
}

if (!customElements.get('product-sku')) {
  customElements.define('product-sku', ProductSku);
}
